const ERROR_CODE = {};

export default ERROR_CODE;
